import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { Calculator, Landmark, Receipt, Percent, FileSpreadsheet, TrendingUp, PiggyBank, KeyRound, BarChart3, Scale, Stamp, GitCompare, ArrowUpRight } from "lucide-react";

const TOOLS = [
  { icon: GitCompare, t: "Property Comparison", d: "Compare & find your best-fit home", id: "compare" },
  { icon: Calculator, t: "EMI Calculator", d: "Monthly instalment + interest breakdown", id: "emi" },
  { icon: Landmark, t: "Loan Eligibility", d: "How much can you borrow?", id: "elig" },
  { icon: BarChart3, t: "ROI Calculator", d: "Return on a property investment", id: "roi" },
  { icon: KeyRound, t: "Rental Yield", d: "Gross & net yield from rent", id: "yield" },
  { icon: Scale, t: "Rent vs Buy", d: "Which is smarter over time?", id: "rvb" },
  { icon: PiggyBank, t: "SIP vs Property", d: "Mutual funds vs real estate", id: "sip" },
  { icon: Receipt, t: "TDS on Property", d: "1% deduction over ₹50L", id: "tds" },
  { icon: Percent, t: "GST Calculator", d: "Under-construction vs ready", id: "gst" },
  { icon: FileSpreadsheet, t: "Cost Sheet Builder", d: "The true all-in cost", id: "cost" },
  { icon: Stamp, t: "Stamp Duty (WB)", d: "West Bengal duty + registration", id: "wb" },
  { icon: TrendingUp, t: "Capital Gains", d: "LTCG with/without indexation", id: "cg" },
];

export function ToolsPreview() {
  return (
    <section className="border-t border-border py-24 md:py-36" data-testid="tools-preview">
      <div className="container-px mx-auto max-w-[1600px]">
        <Reveal>
          <div className="mb-16 flex flex-col justify-between gap-6 md:flex-row md:items-end">
            <div>
              <p className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-cyan">Free Buyer Tools</p>
              <h2 className="font-display text-5xl font-extrabold uppercase leading-none text-foreground md:text-7xl">Do the<br />math first.</h2>
            </div>
            <Link to="/tools" className="group flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-foreground hover:text-cyan" data-testid="tools-preview-all">
              Open all 12 tools <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </div>
        </Reveal>
        <div className="grid gap-px border border-border bg-border md:grid-cols-3">
          {TOOLS.map((tool, i) => (
            <Reveal key={tool.t} delay={(i % 3) * 0.05} className={tool.span || ""}>
              <Link to={`/tools?tab=${tool.id}`} className="group flex h-full min-h-[200px] flex-col justify-between bg-background p-8 transition-colors hover:bg-card" data-testid={`tool-card-${tool.id}`}>
                <tool.icon className="h-7 w-7 text-cyan" strokeWidth={1.5} />
                <div>
                  <h3 className="font-display text-2xl font-bold uppercase text-foreground">{tool.t}</h3>
                  <p className="mt-1 text-sm text-muted-foreground">{tool.d}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
